import { FeaturedSection } from '../../../../../shared/components/blog/FeaturedSection'
import HeroPostTile from '../../../../../shared/components/blog/HeroPostTile'
import PostTiles from '../../../../../shared/components/blog/PostTiles'
import PostTilesList from '../../../../../shared/components/blog/PostTilesList'
import StyledLink from '../../../../../shared/components/global/StyledLink'
import { getBlogPostsByCategory } from '../../../../../shared/lib/api'
import { ArchiveLink, BlogContentGrid, BlogContentSection, MoreBlogPostsSection, TileSizes } from '../../../../../shared/styles/blog/blog'
import { BlogContentList } from '../../../../../shared/styles/blog/bloglist'
import { ButtonSizes, TextButton } from '../../../../../shared/styles/button'
import { Container, ContainerContentFull, ContainerContentNarrow } from '../../../../../shared/styles/container'
import Layout from '../../../components/global/Layout'
import Seo from '../../../components/global/Seo'

const Blog = ({ allPosts: { edges }, featuredPosts, preview }) => {
    const heroPost = edges[0]?.node
    const mediumPosts = edges.slice(1, 5)
    const smallPosts = edges.slice(5, 11)
    const extraSmallPosts = edges.slice(11, 19)

    return (
        <>
            <Layout preview={preview}>
                <Seo
                    title={"Success Stories"}
                    description={"Die Success Stories zum STELL-MICH-EIN."}
                />
                <Container backgroundColor='#f5f5f7'>
                    <ContainerContentNarrow>
                        <BlogContentSection>
                            <h2>Success Stories</h2>
                            <BlogContentGrid role="list" twoColumns>
                                {heroPost && (
                                    <HeroPostTile
                                        title={heroPost.title}
                                        coverImage={heroPost.featuredImage?.node}
                                        date={heroPost.date}
                                        author={heroPost.author?.node}
                                        slug={heroPost.slug}
                                        excerpt={heroPost.excerpt}
                                        categories={heroPost.categories}
                                    />
                                )}
                                {mediumPosts?.length > 0 && <PostTiles posts={mediumPosts} size={TileSizes.m} />}
                            </BlogContentGrid>
                            <BlogContentGrid role="list" twoColumns={false}>
                                {smallPosts?.length > 0 && <PostTiles posts={smallPosts} size={TileSizes.s} />}
                            </BlogContentGrid>
                        </BlogContentSection>
                    </ContainerContentNarrow>
                    <ContainerContentFull>
                        <FeaturedSection posts={featuredPosts.edges} />
                    </ContainerContentFull>
                </Container>
                <Container backgroundColor='#FFFFFF'>
                    <ContainerContentNarrow>
                        <MoreBlogPostsSection>
                            {extraSmallPosts?.length > 0 && (
                                <>
                                    <h2>Mehr von STELL-MICH-EIN</h2>
                                    <BlogContentList role="list" singleCol={false}>
                                        <PostTilesList posts={extraSmallPosts} />
                                    </BlogContentList>
                                </>
                            )}
                            <ArchiveLink>
                                <StyledLink href="/blog/archive">
                                    <TextButton primary size={ButtonSizes.m}>
                                        {"Archiv ansehen >"}
                                    </TextButton>
                                </StyledLink>
                            </ArchiveLink>
                        </MoreBlogPostsSection>
                    </ContainerContentNarrow>
                </Container>
            </Layout >
        </>
    )
}

export default Blog

export async function getStaticProps({ preview = false }) {
    const allPosts = await getBlogPostsByCategory(preview, "Success-Story")
    const featuredPosts = await getBlogPostsByCategory(preview, "Featured")
    return {
        props: { allPosts, featuredPosts, preview },
        revalidate: 120,
    }
}
